import { _ } from "extensions/underscore";
import accounting from "accounting";

import { getDecimalSeparator } from "common/utils";

import { Presenter } from "common/components/table/cells/generic";

export class NumberPresenter extends Presenter {
    itemContent = (column, content, rowModel) => {
        const exactValue = _.propValue(column, "cellOptions.exactValue") || false;
        const prefix = _.propValue(column, "cellOptions.prefix") || "";
        const suffix = _.propValue(column, "cellOptions.suffix") || "";
        let precision;

        if (exactValue) {
            precision = 10;
        } else {
            precision = _.propValue(column, "cellOptions.precision") || 0;
        }

        let formatted = accounting.formatNumber(Math.abs(content), precision);

        if (exactValue) {
            // Remove zeroes at the end of string with decimals
            // As long as the last character is a 0 or a dot, remove it
            const { holder: decimalSeparator } = getDecimalSeparator();
            while ((formatted.includes(decimalSeparator) && formatted.length > 1 && formatted.slice(-1) === "0") || formatted.slice(-1) === decimalSeparator) {
                formatted = formatted.substr(0, formatted.length - 1);
            }
        }

        if (content < 0) {
            formatted = `(${formatted})`;
        }

        return prefix + formatted + suffix;
    };

    /**
     * CSV text for content in the numeric field
     * @param column
     * @param content
     * @param rowModelData
     * @param rowModel
     * @returns {*}
     */
    getCSVContent = (column, content, rowModelData, rowModel) => {
        const prefix = _.propValue(column, "cellOptions.prefix") || "";
        const suffix = _.propValue(column, "cellOptions.suffix") || "";
        const precision = _.propValue(column, "cellOptions.precision") || 0;
        const formatted = accounting.formatNumber(content, precision, "");

        return prefix + formatted + suffix;
    };
}
